import { selectorActiveNotifications } from "./selectorActiveNotifications";

import {
  NotificationHandleType,
  WSNotificationResponse
} from "../components/Notifications";
import { SignatureCollaboratorContext } from "../components/Notifications/templates/SignatureCollaborator";

export const selectorSignatureCollaboratorNotifications = (
  responses: WSNotificationResponse[]
) => {
  return selectorActiveNotifications(responses).filter(response => {
    return response.handle === NotificationHandleType.SignatureCollaborator;
  }) as Array<WSNotificationResponse<SignatureCollaboratorContext>>;
};
